import { EnvironmentType } from "../types/environment.type";
import { IEnvironment } from "./environment.interface";
import { getEnvironmentVariable } from './environment.loader';

export const environment: IEnvironment = {
  ENVIRONMENT_TYPE: EnvironmentType.Base,
  API_URL: getEnvironmentVariable('api-url', 'http://develop.engenharia-vd.totvs.io:15200/api/totvsmoda/'),
  HOST_TOMAS: getEnvironmentVariable('tomas-url', 'http://develop.engenharia-vd.totvs.io:31000/tomascoletorlinha'),
  HOST_MODAWEB: ''
}